import { render } from "./FornitoriDogane.vue?vue&type=template&id=03c87474"
import script from "./FornitoriDogane.vue?vue&type=script&lang=js"
export * from "./FornitoriDogane.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__